export default "__VITE_ASSET__CWQDnm8a__"